<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-30 17:02:04
 * @LastEditors: geory
 * @LastEditTime: 2026-01-16 17:12:26
-->
<template>
  <div class="container">
    <menubar
      from="autoSend"
      title="逐条发送"
    />
    <div v-if="list.length">
      <div class="mainView">
        <div
          class="banner"
          :style="{
            backgroundColor: '#FCF6DF',
          }"
        >
          <img
            class="icon1"
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20251230100719.png"
          />
          逐条发送中请保持聊天窗口置顶在桌面
        </div>
        <div
          v-for="(item, idx) in list"
          :key="idx"
          class="item"
          :ref="'itemRef' + idx"
          :style="{
            color: idx === sendIndex ? '#FB5D5C' : '#3c3c3c',
          }"
          @click="itemClick(idx)"
        >
          <div
            v-if="item.type === 'text'"
            @dblclick.stop="sendItem(item, false)"
          >
            {{ item.val }}
          </div>
          <div
            v-else-if="item.type === 'img'"
            @dblclick.stop="sendItem(item, false)"
          >
            <img
              :style="{
                border: idx === sendIndex ? '5px solid #FB5D5C' : 'none',
              }"
              :src="item.val"
              alt="图片"
              class="imgItem"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!isAutoSending"
        class="controlBar"
      >
        <div
          class="controlBarBtn"
          :style="{
            color: '#fff',
            backgroundColor: '#FB5D5C',
          }"
          @click="autoSendClick"
        >
          <img
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20251230182728.png"
          />
          开始逐条
        </div>
      </div>
      <div
        v-else
        class="controlBar"
      >
        <div
          class="controlBarBtn"
          :style="{
            color: '#43A046',
          }"
          @click="restartSend"
        >
          <img
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20251230181733.png"
          />
          重新发送
        </div>
        <div
          v-if="isPause"
          class="controlBarBtn"
          :style="{
            color: '#4A90E2',
          }"
          @click="resumeSendClick"
        >
          <img
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20251231142820.png"
          />
          继续发送
        </div>
        <div
          v-else
          class="controlBarBtn"
          :style="{
            color: '#4A90E2',
          }"
          @click="pauseSendClick"
        >
          <img
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20251230182027.png"
          />
          暂停发送
        </div>
        <div
          class="controlBarBtn"
          :style="{
            color: '#FB5D5C',
          }"
          @click="cancelSendClick"
        >
          <img
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20251230182244.png"
          />
          取消发送
        </div>
      </div>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  MessageBox,
  Message,
  Radio,
  RadioGroup,
  Switch,
  Button,
} from "element-ui";
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Button);

import axios from "axios";
import menubar from "@/components/menubar";
import Resume from "qiniu-js/esm/upload/resume";

export default {
  name: "AutoSend",
  data() {
    return {
      width: document.documentElement.clientWidth || document.body.clientWidth,
      height:
        document.documentElement.clientHeight || document.body.clientHeight,
      list: [],
      isAutoSending: false,
      sendIndex: 0,
      isPause: false,
      autoTimer: null,
      timeSpace: 1000,
      spaceTime: 1,
      letterSpaceTime: 0.1,
      spaceTimeType: 1, // 1。智能间隔时间（模拟打字速度） 2。自定义间隔时间
      partSplitType: [],
    };
  },
  components: {
    menubar,
  },
  computed: {},
  created() {
    console.log("autosend created...");

    if (window.require) {
      const { ipcRenderer } = window.require("electron");
      let _this = this;

      ipcRenderer.on("stopAutoSending", (event, resp) => {
        this.pauseSendClick();
      });

      ipcRenderer.on("huashuInfo", (event, resp) => {
        _this.list = [];
        _this.sendIndex = 0;
        _this.isPause = false;
        _this.isAutoSending = false;

        _this.huashuInfo = resp.huashuInfo;
        console.log("huashuInfo:", _this.huashuInfo);
        ipcRenderer.send("getSettingInfo");
      });
      ipcRenderer.on("getSettingInfoResp", (event, settingInfo) => {
        if (settingInfo) {
          console.log("settting getSettingInfoResp settingInfo:", settingInfo);
          _this.settingInfo = JSON.parse(settingInfo);
          // if (_this.settingInfo && _this.settingInfo.version) {
          //   if (_this.isVersionLessThan("1.2.0", _this.settingInfo.version)) {
          //     _this.cancelTopBtnShow = true;
          //   }
          // }
          _this.letterSpaceTime = _this.settingInfo.letterSpaceTime;
          _this.spaceTimeType = _this.settingInfo.spaceTimeType;
          _this.spaceTime = _this.settingInfo.spaceTime;
          _this.timeSpace = _this.spaceTime * 1000;
          _this.partSplitType = _this.settingInfo.partSplitType;
          if (_this.huashuInfo) {
            _this.handleSplit();
          }
        }
      });
    }
  },
  methods: {
    handleSplit() {
      let _this = this;
      if (this.huashuInfo) {
        if (this.huashuInfo.editHuashuData.speechText) {
          let list = [];
          this.huashuInfo.editHuashuData.eleList.forEach((item) => {
            if (item.val) {
              if (item.type === "text") {
                // let textList = _this.splitByNewLine(item.val);
                let textList = _this.splitByConfig(
                  item.val,
                  _this.partSplitType
                );
                textList.forEach((textItem) => {
                  list.push({
                    type: "text",
                    val: textItem,
                  });
                });
              } else {
                list.push(item);
              }
            }
          });
          _this.list = list;
        }
      }
    },
    itemClick(idx) {
      if (this.isPause || !this.isAutoSending) {
        this.sendIndex = idx;
      }
    },
    restartSend() {
      this.isAutoSending = false;
      this.sendIndex = 0;
      this.isPause = false;
    },
    cancelSendClick() {
      if (this.autoTimer) {
        clearTimeout(this.autoTimer);
        this.autoTimer = null;
      }
      this.isAutoSending = false;
      this.isPause = false;
      this.sendIndex = 0;

      if (window.require && window.require("electron")) {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("autoSending", 0);
        ipcRenderer.send("closeAutoSend");
      }
    },
    pauseSendClick() {
      this.isPause = true;
    },
    resumeSendClick() {
      this.isPause = false;
      this.sendNext();
    },
    async autoSendClick() {
      console.log("autoSendClick...");
      // 开始发送
      this.sendNext();
    },
    async sendNext() {
      this.isAutoSending = true;
      if (window.require && window.require("electron")) {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("autoSending", 1);
      }
      //根据字符串长度间隔时间发送
      let canSendNext = true;
      if (this.sendIndex < this.list.length) {
        let item = this.list[this.sendIndex];
        // if (item.type === "text") {
        if (item.type === "text" && this.spaceTimeType == 1) {
          //按字数间隔发送
          //计算字符串长度，每个中文字符和英文字符占用0.2秒
          let textLength = item.val.replace(/[^\x00-\xff]/g, "aa").length;
          this.timeSpace = textLength * this.letterSpaceTime * 1000;
        } else if (item.type === "text" && this.spaceTimeType == 2) {
          //按时间间隔发送
          this.timeSpace = this.spaceTime * 1000;
        }

        if (this.isAutoSending && !this.isPause && canSendNext) {
          canSendNext = false;
          // 发送当前项
          let sendResult = await this.sendItem(item);
          // }
          if (sendResult) {
            // 递归调用，发送下一项
            this.sendIndex++;
            if (this.sendIndex >= this.list.length) {
              this.isAutoSending = false;
              this.sendIndex = 0;
              clearTimeout(this.autoTimer);
              this.autoTimer = null;
              // 通知主进程逐条发送已完成，恢复吸附
              const { ipcRenderer } = window.require("electron");
              ipcRenderer.send("autoSending", 0);
            } else {
              canSendNext = true;
              this.timeSpace = this.timeSpace < 500 ? 500 : this.timeSpace;
              this.autoTimer = setTimeout(this.sendNext, this.timeSpace);
            }
            //发送时滚动到当前项
            this.$refs["itemRef" + this.sendIndex][0].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          } else {
            clearTimeout(this.autoTimer);
            this.autoTimer = null;
          }
        }
      }
    },
    async sendItem(item, isDbl = true) {
      return new Promise(async (resolve, reject) => {
        if (item.type === "text") {
          navigator.clipboard.writeText(item.val).then(
            () => {
              // if(this.tools.isElectron){
              // this.$message({
              //   message: "文本已复制",
              //   type: "success",
              // });
              console.log("item.val==", item.val);
              const { ipcRenderer } = window.require("electron");
              ipcRenderer.send("type-text", item.val, true, true);
              // }
              ipcRenderer.on("textSendFinish", (event, arg) => {
                resolve(true);
              });
            },
            (err) => {
              console.error("复制失败:", err);
              this.pauseSendClick();
              resolve(false);
            }
          );
        } else if (item.type === "img") {
          // try {
          //   console.log("fetchItem:", item.val);
          //   // 1. 获取图片数据并转为 Blob
          //   const response = await fetch(item.val);
          //   const blob = await response.blob();

          //   // 2. 创建 ClipboardItem 对象
          //   // 注意：目前大多数浏览器剪贴板主要支持 'image/png' 格式
          //   // 如果原始图片是 jpg，建议通过 canvas 转成 png 提高兼容性
          //   const copyitem = new ClipboardItem({
          //     [blob.type]: blob,
          //   });

          //   // 3. 写入剪贴板
          //   await navigator.clipboard.write([copyitem]);
          //   // this.$message({
          //   //   message: "图片已复制",
          //   //   type: "success",
          //   // });
          //   console.log("item.val==", copyitem.val);
          //   const { ipcRenderer } = window.require("electron");
          //   ipcRenderer.send("type-img", isDbl, true);
          //   ipcRenderer.on("imgSendFinish", (event, arg) => {
          //     setTimeout(() => {
          //       resolve(true);
          //     }, 1000);
          //   });
          // } catch (err) {
          //   // console.error("图片复制失败:", err);
          //   this.$message({
          //     message: "图片复制失败",
          //     type: "error",
          //   });
          //   this.pauseSendClick();
          //   resolve(false);
          // }
          try {
            console.log("fetchItem:", item.val);

            // 1. 获取图片数据
            const response = await fetch(item.val);
            let blob = await response.blob();

            // --- 新增逻辑：如果是 JPEG 格式，转换为 PNG ---
            if (blob.type === "image/jpeg" || blob.type === "image/jpg") {
              // 创建一个 Image 对象来加载数据
              const img = new Image();
              const imgUrl = URL.createObjectURL(blob);
              img.src = imgUrl;

              // 等待图片加载完成
              await new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = reject;
              });

              // 创建 Canvas 并绘制图片
              const canvas = document.createElement("canvas");
              canvas.width = img.naturalWidth;
              canvas.height = img.naturalHeight;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);

              // 将 Canvas 内容导出为 PNG 格式的 Blob
              // 覆盖之前的 jpeg blob
              blob = await new Promise((resolve) =>
                canvas.toBlob(resolve, "image/png")
              );

              // 清理 URL 对象，释放内存
              URL.revokeObjectURL(imgUrl);
            }
            // --- 新增逻辑结束 ---

            // 2. 创建 ClipboardItem 对象
            // 此时 blob 已经是 png 格式，或者原图本身就是支持的格式
            const copyitem = new ClipboardItem({
              [blob.type]: blob,
            });

            // 3. 写入剪贴板
            await navigator.clipboard.write([copyitem]);

            // 保持原有逻辑
            // this.$message({
            //   message: "图片已复制",
            //   type: "success",
            // });

            // 注意：copyitem 本身没有 val 属性，这里打印可能会是 undefined，不过不影响功能
            console.log("Write success, type:", blob.type);

            const { ipcRenderer } = window.require("electron");
            ipcRenderer.send("type-img", isDbl, true);
            ipcRenderer.on("imgSendFinish", (event, arg) => {
              setTimeout(() => {
                resolve(true);
              }, 1000);
            });
          } catch (err) {
            console.error("图片复制失败详情:", err); // 建议把错误打印出来方便调试
            this.$message({
              message: "图片复制失败: " + (err.message || "未知错误"),
              type: "error",
            });
            this.pauseSendClick();
            resolve(false);
          }
        }
      });
    },
    /**
     * 根据动态配置的符号分割字符串，并将分割符保留在上一段内容的末尾
     * 例如：输入 "A,B;C" -> 输出 ["A,", "B;", "C"]
     * @param {string} str - 需要分割的原始字符串
     * @param {Array} partSplitType - 配置数组
     * @returns {string[]} 分割后的非空字符串数组
     */
    splitByConfig(str, partSplitType) {
      // 1. 边界处理
      if (typeof str !== "string" || str === "") {
        return [];
      }

      // 2. 提取所有勾选（checked: 1）的分割符
      const activeSymbols = partSplitType
        .filter((item) => item.checked === 1)
        .flatMap((item) => item.val);

      if (activeSymbols.length === 0) {
        return [str];
      }

      // 3. 构建正则表达式
      const escapedSymbols = activeSymbols.map((s) =>
        s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      );

      // 使用捕获组 ((?:...)+) 确保 split 后分割符单独成为数组元素
      // 结果示例：["内容1", "分隔符1", "内容2", "分隔符2", "内容3"]
      const regex = new RegExp(`((?:${escapedSymbols.join("|")})+)`);

      // 4. 执行分割
      const rawSplit = str.split(regex);
      const result = [];

      // 5. 遍历并合并 (步长为2)
      // rawSplit 的偶数索引是内容，奇数索引是捕获的分割符
      for (let i = 0; i < rawSplit.length; i += 2) {
        const content = rawSplit[i];
        const separator = rawSplit[i + 1] || ""; // 最后一项可能没有分隔符，取空字符串

        // 拼接 内容 + 分隔符
        // 可以在这里加 trim()，例如：(content + separator).trim()
        // const combined = separator != "<分段>" ? content + separator : content;
        const combined = !separator.includes("<分段>")
          ? content + separator
          : content;

        // 过滤掉因为开头就是分隔符产生的纯空项（视具体需求而定）
        // 如果 combined 有值（或者只是分隔符），则加入结果
        if (combined && combined.trim() !== "") {
          result.push(combined); // 推荐这里 trim() 一下防止加入纯空格，除非需要保留格式
        }
      }

      return result;
    },
  },
};
</script>
<style scoped>
.container {
  background-color: #e3e3e3;
}

.mainView {
  /* height: 420px; */
  padding-top: 80px;
  padding-bottom: 64px;
  /* min-height: 386px; */
  background-color: #fff;
  position: relative;
  overflow: scroll;
}

.banner {
  display: flex;
  align-items: center;
  padding: 10px;
  position: fixed;
  top: 32px;
  left: 0;
  right: 0;
}

.item {
  padding: 10px 0;
  margin: 0 10px;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
  color: #333;
  background-color: #fff;
}

.imgItem {
  width: 138px;
  height: 138px;
  margin-left: 8px;
  margin-bottom: 8px;
  object-fit: cover;
}

.controlBar {
  background-color: #f5f6f6;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.controlBarBtn {
  width: 100px;
  height: 30px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.controlBarBtn img {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

.icon1 {
  width: 14px;
  height: 16px;
  margin-left: 16px;
  margin-right: 8px;
}
</style>
